<template>
  <div
    class="d-swiperItem swiper-slide"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DSwiperItem'
}
</script>

<style lang="scss" scoped>
.d-swiperItem {
  @include link-effect;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
